package com.essntl.features.service.domain.model.extraservice

import com.essntl.features.service.domain.model.service.ServiceModel

data class ExtraServiceModel(
    val id: String,
    val createdAt: String,
    val service: ServiceModel,
    val updatedBy: String?,
    val description: String?,
    val unitPrice: Int?,
    val quantity: Int?,
) {
    companion object {
        val empty = ExtraServiceModel(
            id = "",
            createdAt = "",
            service = ServiceModel.empty,
            updatedBy = null,
            description = null,
            unitPrice = null,
            quantity = null,
        )
    }
}
